import Mock from "mockjs";

//getAll:/api/tutorials
Mock.mock(/\/api\/sexandcompanysummarychart/, "get",{
        message: '資料查詢成功',
        result: {
            count: 5,
            items:{
            'AXA': [15, 20], //保險公司: [男性人數, 女性人數]
            'AAA': [15, 20], 
            'BBB': [15, 20], 
            'CCC': [15, 20], 
            '保誠': [180, 240]
            }
        }
    }
);